<template>
	<inertia-head title="Verify Email" />
	<div class="text-center">
		<div class="display-1 fw-bold text-primary">
			<i class="fa fa-envelope-open-text opacity-50 me-1"></i>
		</div>
		<h1 class="fw-bold mt-5 mb-2">Please verify your email</h1>
		<h6 class="fs-6 fw-small text-muted mb-5">
			You're almost there! We sent an email to
			<div class="clearfix"></div>
			<span class="text-primary">{{ $page.props.user.email }}</span>
		</h6>
		<p>
			Click the link on your email to activate your account.
			<br />
			If it is not in your <strong>inbox</strong>, you may need to
			<strong>check your spam</strong> folder.
		</p>
		<p>Still can't find the email?</p>
		<button v-if="!is_process" @click="resendEmail" class="btn btn-alt-primary w-100 py-3 fw-semibold mb-4">
			Resend Email
		</button>
		<button v-else class="btn btn-alt-primary btn-disabled w-100 py-3 fw-semibold mb-4" disabled="true">
			<div class="spinner-border spinner-border-sm text-dark" role="status" >
				<span class="sr-only mr-1">Processing...</span>
			</div>
			<span class="mx-2">Processing...</span>
		</button>
		<p>Need help? Email us at support@trulyrichclub.com or call us at +63 917-500-9671 / +63 919-095-2512 / - (02)7904-0598</p>
		<p>
			<inertia-link
				:href="route('post.logout')"
				method="post"
				as="button"
				class="dropdown-item text-center"
			>
				Logout
			</inertia-link>
		</p>
	</div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'
import GuestLayout from '../../Layouts/GuestLayout'
import { watch, ref } from 'vue'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: GuestLayout,
	props: {
		flash: Object,
	},
	setup(props) {
		const is_process = ref(false);
		const resendEmail = () => {
			Inertia.post(route('post.resend-verification-link'),{},
				{
					onStart:()=>{
						is_process.value = true;
					},
					onSuccess:()=>{
						is_process.value = false;
					},
					onError:()=>{
						is_process.value = false;
					}
				})
		}

		return {
			is_process,
			resendEmail,
		}
	},
}
</script>
